import React, { Component } from "react";
import "./AppointmentCreated.less";

class AppointmentCreated extends Component {
  render() {
    const { selectedDate, selectedHour } = this.props;

    return (
      <div className="appointment-container">
        <h2 className="title">Gracias por completar tu solicitud</h2>
        <div className="separator"></div>
        <p className="description">
          Hemos programado tu contacto con un asesor para brindarte toda la información sobre tu cotización el día
        </p>

        <div className="appointment-details">
          <p className="weekday">{selectedDate?.weekday}</p>
          <p className="day">{selectedDate?.day}</p>
          <p className="month">{selectedDate?.month}</p>
          <p className="hour">{selectedHour}</p>
        </div>
      </div>
    );
  }
}

export default AppointmentCreated;
